// extracted by mini-css-extract-plugin
export var container = "_eg-0";
export var segment = "_eg-2";
export var segmentActive = "_eg-3";
export var track = "_eg-1";